export const MERCHANT_PORTAL_BASE = "https://book.qiktruck.co.za";
export const DEFAULT_OG_IMAGE = "https://media.qiktruck.co.za/qiktruck-preview-header.webp";
export const TWITTER_HANDLE = "qiktrucksa";
